// extracted by mini-css-extract-plugin
export default {"TemplateEditorContainer":"TemplateEditor_TemplateEditorContainer__yu4jM","EditorTextarea":"TemplateEditor_EditorTextarea__7lPfO"};